module.exports = __webpack_public_path__ + "images/supershare-icon.png";